const ScopeComponent = (Component) => {
  if (!Component.mounted) {
    Component.mounted = [];
  } else if (!Array.isArray(Component.mounted)) {
    Component.mounted = [Component.mounted];
  }
  Component.mounted.push(function() {
    this.$el.setAttribute(`data-v-${"dd4fb6c"}`, "");
  });
};
export {
  ScopeComponent as S
};
//# sourceMappingURL=ScopeComponent-B_NOkzpc.mjs.map
